module.exports = __webpack_public_path__ + "testimonials-header.jpg?dd1b1fb956dceb213cf10814df0a8941";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials-header.jpg
// module id = 81
// module chunks = 0